	// tabs affichage
	document.addEventListener("DOMContentLoaded", function () {
		const btnReco = document.getElementById("btn-reco");
		const btnViewed = document.getElementById("btn-viewed");
		const produitsReco = document.getElementById("produits-reco");
		const produitsViewed = document.getElementById("produits-viewed");
	
		btnReco.addEventListener("click", function () {
		  produitsReco.classList.add("active");
		  produitsViewed.classList.remove("active");
		  btnReco.classList.add("active");
		  btnViewed.classList.remove("active");
		});
	
		btnViewed.addEventListener("click", function () {
		  produitsViewed.classList.add("active");
		  produitsReco.classList.remove("active");
		  btnViewed.classList.add("active");
		  btnReco.classList.remove("active");
		});
	  });
	
	  
	// SPLIDE RECO
	function mmSetupSplideRecos() {
		const splideRecoElem = document.querySelector('.mm-splide-reco');
	
		if (!splideRecoElem) {
			console.warn("Élément .mm-splide-reco non trouvé.");
			return;
		}
	
		const progressBarReco = splideRecoElem.querySelector('.mm-splide-progress-bar');
		const splideReco = new Splide(splideRecoElem, {
			type: 'slide',
			arrows: false,
			pagination: false,   
			perMove: 1,
			perPage: 3,
			omitEnd: true,
			gap: 16,   
			breakpoints: {
				768: { 
					gap: 16,
					perMove: 1,
					perPage: 1   
				},
			},
		});
	
		// Mise à jour de la progress bar
		if (progressBarReco) {
			const updateProgressBarReco = () => {
				const totalPagesReco = splideReco.Components.Elements.slides.length;
				const currentPageReco = splideReco.index + 1; 
				const progressReco = (currentPageReco / totalPagesReco) * 100;
				progressBarReco.style.width = `${progressReco}%`;
			};
	
			splideReco.on('move', updateProgressBarReco);
			splideReco.on('mounted', updateProgressBarReco);
		}
	
		splideReco.mount();
	}
	
	// SPLIDE VIEW + COLLEC
	function mmSetupSplideRecentlyViewedCo() {
		const splideElems = document.querySelectorAll('.mm-product-recent-splide-collection');
	  
		splideElems.forEach((splideElemViewCo) => {
		  // Évite de réinitialiser s'il est déjà monté
		  if (splideElemViewCo.classList.contains('is-splide-initialized')) return;
	  
		  splideElemViewCo.classList.add('is-splide-initialized');
	  
		  const progressBarCo = splideElemViewCo.querySelector('.mm-splide-progress-bar');
	  
		  const splideViewCo = new Splide(splideElemViewCo, {
			type: 'slide',
			arrows: false,
			pagination: false,
			perMove: 1,
			perPage: 3,
			omitEnd: true,
			gap: 16,
			breakpoints: {
			  768: {
				perMove: 1,
				perPage: 1,
				gap: 16
			  },
			},
		  });
	  
		  // Progress bar
		  if (progressBarCo) {
			const updateProgressBar = () => {
			  const totalSlides = splideViewCo.Components.Elements.slides.length;
			  const currentSlide = splideViewCo.index + 1;
			  const progress = (currentSlide / totalSlides) * 100;
			  progressBarCo.style.width = `${progress}%`;
			};
	  
			splideViewCo.on('move', updateProgressBar);
			splideViewCo.on('mounted', updateProgressBar);
		  }
	  
		  splideViewCo.mount();
		});
	  }
	  
	  // Appel sécurisé au bon moment
	  document.addEventListener('DOMContentLoaded', mmSetupSplideRecentlyViewedCo);
	

	
	

